// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1698":"18581021","2860":"5583c8ec","3734":"685a2d8f","3942":"056698d0","4242":"bb9d3a46","4441":"4aa62ab0","4483":"7bae20aa","5431":"40d945be","8019":"685a2d8f"}[chunkId] + ".chunk.css";
};